import { useEffect, useRef, useState } from "react";
import "./MultiSelectFilter.css";
import { encode, printDebugLog } from "../../Utils/utils";
import { WEBSITE_SHOP_HASH } from "../../Utils/constant";
import { GET } from "../../Network/snpaxios";

// const mockData = [
//   "Apple", "Banana", "Orange", "Pineapple", "Mango",
//   "Blueberry", "Blackberry", "Grapes", "Peach", "Pear",
// ];

const MultiSelectFilter = ({ initialBrands = [], filtersDispatch }) => {


  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState(initialBrands || []);
  const [showAllTags, setShowAllTags] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const inputRef = useRef(null);
  const dropdownRef = useRef(null);


  useEffect(() => {
    printDebugLog("brandFilter", initialBrands)
  }, [initialBrands])


  const getListBrands = async (inputValue) => {
    try {
      const encodedShopHash = encode(WEBSITE_SHOP_HASH);
      const response = await GET(`ext/cart/list-brands?shopHash=${encodedShopHash}&query=${inputValue}`);
      if (response !== null) {
        return response.listBrands;
      }
    } catch (error) {
      console.error(`getListBrands(${inputValue})`, error);
    }
    return null;
  }


  useEffect(() => {
    async function fetchData() {
      const results = await getListBrands(inputValue);
      const items = Array.isArray(results) ? results : results?.data || [];

      const finalResults = items.filter(
        (item) => !selectedItems.includes(item)
      );
      setFilteredOptions(finalResults);
    }
    if (inputValue.length >= 3) {
      // const results = mockData.filter(
      //   (item) =>
      //     item.toLowerCase().includes(inputValue.toLowerCase()) &&
      //     !selectedItems.includes(item)
      // );
      fetchData();
    } else {
      setFilteredOptions([]);
      setHighlightedIndex(-1);
    }
  }, [inputValue, selectedItems]);



  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSelect = (item) => {
    if (!selectedItems.includes(item)) {
      const updated = [...selectedItems, item];
      setSelectedItems(updated);
      filtersDispatch({
        type: "setBrandFilter",
        payload: item,
      });
    }
    setInputValue("");
    setFilteredOptions([]);
    setHighlightedIndex(-1);
  };

  const handleRemove = (item) => {
    printDebugLog("handleRemove", item);
    const updated = selectedItems.filter((i) => i !== item);
    setSelectedItems(updated);
    filtersDispatch({
      type: "setRemoveBrandFilter",
      payload: item,
    });
  };

  const visibleTags = showAllTags ? selectedItems : selectedItems.slice(0, 2);
  const hiddenCount = selectedItems.length - 2;

  const handleKeyDown = (e) => {
    if (filteredOptions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev + 1) % filteredOptions.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev <= 0 ? filteredOptions.length - 1 : prev - 1
      );
    } else if (e.key === "Enter" && highlightedIndex >= 0) {
      handleSelect(filteredOptions[highlightedIndex]);
    }
  };

  return (
    <div className="multi-select-wrapper">
      <div className="tag-container">
        {visibleTags.map((item) => (
          <span key={item} className="tag">
            {item}
            <button onClick={() => handleRemove(item)}>&times;</button>
          </span>
        ))}

        {hiddenCount > 0 && (
          <span
            className="more-tag"
            onClick={() => setShowAllTags((prev) => !prev)}
          >
            {showAllTags ? "Show less" : `+${hiddenCount} more`}
          </span>
        )}

        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Search Brand"
        />
      </div>

      {filteredOptions.length > 0 && (
        <ul className="dropdown" ref={dropdownRef}>
          {filteredOptions.map((item, index) => (
            <li
              key={item}
              onClick={() => handleSelect(item)}
              className={index === highlightedIndex ? "highlighted" : ""}
            >
              <div style={{
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: index % 2 === 0 ? "#e6f7ff" : "white",
                background: "white",
                cursor: "pointer",
                color: "var(--dark-background-color)",
                fontFamily: 'Source Sans Pro',
              }}>
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "16px" }}>{item}</p>
              </div>

            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
export { MultiSelectFilter };
